<template>
<div  class="achievementadd">
     <div class="header">    
        <el-button size="medium" type="default" @click.native="$router.back()">返回</el-button>  
        <el-button type="primary" size="medium" @click="insertTemplates('ruleForm')">保存</el-button>
     </div>
     <div class="subject" :style="`height: ${windowHeight - 180}px;`">
       <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">  
               <el-form-item label="模板名称" prop="templateName">
                    <el-input v-model.trim="ruleForm.templateName" placeholder="请输入模板名称" maxlength="30"></el-input>                
                </el-form-item>
                <el-form-item label="学段" prop="schoolTypeId">
                  <el-select v-model="ruleForm.schoolTypeId" :disabled="true" placeholder="请选择学段" @change="getCurrBySchoolTypes()">
                    <el-option :label="item.name" :key="item.id" :value="item.id" v-for="item in schoolTypelist"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="学科" prop="currId">
                  <el-select v-model="ruleForm.currId" placeholder="请选择学科" :disabled="true">
                    <el-option :label="item.name" :key="item.id" :value="item.id" v-for="item in currlist"></el-option>
                  </el-select>
                </el-form-item>  
                <el-form-item label="选择分类" >  
                        <el-radio class="radio" :disabled="true" v-model="largeSmall" label="1">按大题</el-radio>
                        <el-radio class="radio" :disabled="true" v-model="largeSmall" label="0">按小题</el-radio>
                        &nbsp;&nbsp;
                        <el-checkbox v-model="orderWay" :disabled="true" v-if="largeSmall!=1" @change="funorderWay()">题号连续</el-checkbox>
                </el-form-item>               
        </el-form>
        <div class="boxlist">
             <div class="subject-title">
                  题型及分数 <i class="el-icon-plus" title="添加" @click="plusadd()"></i>
            </div>
            <div class="bigquestionlist" v-if="largeSmall==1">
                <div class="largebox" :key="index"  v-for="(items,index) in bigquestionlist">
                    第{{index+1}}大题:
                    <div class="input-box">
                            <el-select size="medium" filterable  v-model="items.queTypeId"   placeholder="请选择题型">
                                <el-option :label="item.value" :key="item.id" :value="item.id" v-for="item in questiontypelist"></el-option>
                           </el-select>
                    </div>
                    分数：
                   <div class="input-box">
                           <el-input size="medium" v-model="items.totalScore" :maxlength="3"  placeholder="请输入分数"  @blur="verification(items.totalScore,index)"></el-input>
                   </div>
                   <i class="el-icon-minus" title="删除" @click="minusdelete(index)"></i>
                </div>  

            </div>
             <div class=" smallquestionlist" v-if="largeSmall==0">
                <div class="largebox" :key="indexs"  v-for="(items,indexs) in smallquestionlist">
                    第{{indexs+1}}大题:        
                    <div class="input-box">
                            <el-select size="medium" filterable  placeholder="请选择题型" v-model="items.queTypeId">
                             <el-option :label="item.value" :key="item.id" :value="item.id" v-for="item in questiontypelist"></el-option>
                           </el-select>
                    </div>
                    小题数：
                   <div class="input-box input-box-big">
                           <el-input size="medium" v-model="items.num" placeholder="请输入小题数"  @blur="minortopicnum(items.num,indexs,items.questionnum)"></el-input>                           
                   </div>
                   默认每题分数：
                   <div class="input-box input-box-big">
                           <el-input size="medium" v-model="items.questionnum" placeholder="请输入分数"  @blur="questionnum(items.questionnum,indexs)"></el-input>                           
                   </div>
                    <i class="el-icon-minus" title="删除" @click=" minusdelete(indexs)"></i>
                   <div class="formlist">
                    题数及分数：
                    <div class="tablebox" v-if="smallquestionlist[indexs].numlist[0].datalist.length>0">
                           <el-table  :data="items.numlist"  border>
                            <el-table-column  label="题号" fixed  prop="fenshu"  align="center"  width="150px"></el-table-column>                        
                            <el-table-column  :key="index" v-for="(item,index) in smallquestionlist[indexs].numlist[0].datalist" align="center" :label="item.name"  >
                                  <template scope="scope">
                                     <el-input size="medium" :maxlength="3" v-model="scope.row.datalist[index].num" @blur="cumulative(scope.row.datalist[index].num,index,indexs)"  placeholder="请输分数"></el-input>
                                  </template>                
                            </el-table-column> 
                            <el-table-column  label="总计" fixed="right"  prop="totalScore"   align="center"  width="150px"> </el-table-column>
                          </el-table>
                    </div>
                   </div>
                </div>  
            </div>
        </div>
     </div>
</div> 
</template>
<script>
import {
  getCurrBySchoolType,
  getCurrQuestion,
  insertTemplate,getTempalteDetails
} from "@/api/achievement";
import windowResize from "@/mixins/windowResize";
export default {
  name: "dataAnalysis",
  data() {
    return {
      id:this.$route.query.id,//模板id
      schoolTypelist: [
        // { name: "幼儿园", id: 1 },
        { name: "小学", id: 2 },
        { name: "初中", id: 3 },
        { name: "高中", id: 4 },
        // { name: "六年制", id: 6 },
        // { name: "九年制", id: 9 },
        // { name: "十二年制", id: 12 },
        // { name: "特殊学校", id: 10 }
      ],
      subjectlist: [],
      currlist: [],
      ruleForm: {
        currId: "", //	科目id	number
        schoolTypeId: 2, //	学校类型	number
        templateName: ""
      },
      rules: {
        currId: [{ required: true, message: "请选择学科", trigger: "change" }],
        schoolTypeId: [
          { required: true, message: "请选择学段", trigger: "change" }
        ],
        templateName: [
          { required: true, message: "请输入模板名称", trigger: "blur" }
        ]
      },
      largeSmall: "1",
      orderWay: false,
      questiontypelist: [], //题型list
      bigquestionlist: [], //大题list
      smallquestionlist: [] //小题list
    };
  },
  mixins: [windowResize],
  created() {
    this.getTempalteDetailss();    
  },
  methods: {   
    //获取题型
    getCurrQuestions() {
      getCurrQuestion(this.ruleForm.currId)
        .then(res => {
          const data = res.data.data;
          this.questiontypelist = data;          
        })
        .catch(err => {});
    },
    //添加题目
    plusadd() {
      if (this.largeSmall == 1) {
        this.bigquestionlist.push({ totalScore: "", queTypeId: "" });
      }
      if (this.largeSmall == 0) {
        this.smallquestionlist.push({
          questionnum: "1",
          num: "",
          queTypeId: "",
          numlist: [{ datalist: [], fenshu: "分数", totalScore: 0 }]
        });
      }
    },
    //验证是否为正整数
    verification(totalScore, index) {
      let reg = /^\d+(?=\.{0,1}\d+$|$)/;
      if (!reg.test(totalScore.trim()) && totalScore != "") {
        this.$message.error("请输入正数！");
        this.bigquestionlist[index].totalScore = "";
      }
      if (totalScore == 0) {
        this.$message.error("请输入非零正数！");
        this.bigquestionlist[index].totalScore = "";
      }
    },
    //删除大题目
    minusdelete(index) {
      if (this.largeSmall == 1) {
        this.bigquestionlist.splice(index, 1);
      } else {
        this.smallquestionlist.splice(index, 1);
        this.funorderWay();
      }
    },
    //小题数目
    minortopicnum(num, index, questionnum) {
      let reg = /^\d+(?=\.{0,1}\d+$|$)/;
      if (!reg.test(num.trim())) {
        this.$message.error("请输入正数！");
        this.smallquestionlist[index].numlist[0].datalist = [];
        this.smallquestionlist[index].num = "";
      } else {
        this.smallquestionlist[index].numlist[0].datalist = [];
        for (let i = 0; i < num; i++) {
          this.smallquestionlist[index].numlist[0].datalist.push({
            num: questionnum,
            name: i + 1
          });
        }
        this.smallquestionlist[index].numlist[0].totalScore =
          this.smallquestionlist[index].numlist[0].datalist.length *
          questionnum;
        this.funorderWay();
      }
    },
    //循环题号
    funorderWay() {
      let num = 1;
      if (this.orderWay) {
        for (let i = 0; i < this.smallquestionlist.length; i++) {
          for (
            let j = 0;
            j < this.smallquestionlist[i].numlist[0].datalist.length;
            j++
          ) {
            this.smallquestionlist[i].numlist[0].datalist[j].name = num;
            num++;
          }
        }
      } else {
        for (let i = 0; i < this.smallquestionlist.length; i++) {
          for (
            let j = 0;
            j < this.smallquestionlist[i].numlist[0].datalist.length;
            j++
          ) {
            this.smallquestionlist[i].numlist[0].datalist[j].name = j + 1;
          }
        }
      }
    },
    //小题分数
    questionnum(num, index) {
      let reg = /^\d+(?=\.{0,1}\d+$|$)/;
      if (!reg.test(num.trim())) {
        this.$message.error("请输入正数！");
        this.smallquestionlist[index].numlist[0].totalScore = "";
        for (
          let i = 0;
          i < this.smallquestionlist[index].numlist[0].datalist.length;
          i++
        ) {
          this.smallquestionlist[index].numlist[0].datalist[i].num = "";
        }
        this.smallquestionlist[index].questionnum = "";
      } else {
        for (
          let i = 0;
          i < this.smallquestionlist[index].numlist[0].datalist.length;
          i++
        ) {
          this.smallquestionlist[index].numlist[0].datalist[i].num = num;
        }
        this.smallquestionlist[index].numlist[0].totalScore =
          this.smallquestionlist[index].numlist[0].datalist.length * num;
      }
    },
    //累计总分
    cumulative(num, index, indexs) {
      let reg = /^\d+(?=\.{0,1}\d+$|$)/;
      if (!reg.test(num.trim())) {
        this.$message.error("请输入正数！");
        this.smallquestionlist[indexs].numlist[0].datalist[index].num = "";
      }
      let cumulative = 0;
      for (
        let i = 0;
        i < this.smallquestionlist[indexs].numlist[0].datalist.length;
        i++
      ) {
        if (this.smallquestionlist[indexs].numlist[0].datalist[i].num) {
          cumulative =
            cumulative / 1 +
            this.smallquestionlist[indexs].numlist[0].datalist[i].num / 1;
        }
      }
      this.smallquestionlist[indexs].numlist[0].totalScore = cumulative;
    },
    getCurrBySchoolTypes() {
      this.currlist = [];
      getCurrBySchoolType(this.ruleForm.schoolTypeId)
        .then(res => res.data)
        .then(data => {
          for(let i=0;i<data.length;i++){
            if(data[i].examType==1){
               this.currlist.push(data[i])
            }
          }
          if (this.currlist.length > 0) {
            this.getCurrQuestions();
          } else {
            this.ruleForm.currId = "";
            this.questiontypelist = [];
          }
        });
    },
    getTempalteDetailss(){
     getTempalteDetails(this.id) .then(res => {
            const data = res.data.data;
            this.ruleForm.currId =data.currId;
            this.ruleForm.templateName=data.templateName;
            this.ruleForm.schoolTypeId=data.schoolTypeId;
            this.largeSmall=data.isBig+'';
            this.orderWay=(data.orderWay==0);            
            if(data.isBig==1){ 
                this.bigquestionlist=data.questionList;
            }else{                
                let arrqueCount=[]; 
                let judge='';          
                for(let i=0;i<data.questionList.length;i++){ 
                    judge=false;                   
                    for(let j=0;j<arrqueCount.length;j++){
                      if(arrqueCount[j]==data.questionList[i].topicNum){
                        judge=true;
                      };
                   };
                   if(!judge){
                      arrqueCount.push(data.questionList[i].topicNum);                      
                   };
                };
                 for(let j=0;j<arrqueCount.length;j++){
                     let obj ={queTypeId:'',num:'',numlist:[{datalist:[],fenshu:'分数',totalScore:'',}]};
                     for(let i=0;i<data.questionList.length;i++){                    
                      if(arrqueCount[j]==data.questionList[i].topicNum){
                          obj.numlist[0].datalist.push({
                            name:data.questionList[i].queNum,
                            num:data.questionList[i].queScore,
                          });
                          obj.numlist[0].totalScore=data.questionList[i].totalScore;
                          obj.queTypeId=data.questionList[i].queTypeId;
                          obj.num=data.questionList[i].queCount;
                      };                    
                    };
                      this.smallquestionlist.push(obj);
                };
            };
            this.getCurrBySchoolTypes();
        })
        .catch(err => {});
    },
    //新增模版
    insertTemplates(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let query = {
            currId: this.ruleForm.currId, //	学科id	number
            currName: "", //	学科名称	string
            isBig: this.largeSmall, //	大题1，小题0	number
            isPublic: 1, //	公共模板传1	number
            orderWay: 1, //	排序方式，默认0,0代表所有小题题号顺序排，1代表每大题下的小题重新排序	number
            questionJson: [], //	题目	array<object>
            schoolId: 0, //	公共模板传0	number
            schoolPublic: 1, //	是否供全校使用，1代表可以	number
            schoolType: "", //	学校类型名称	string
            schoolTypeId: this.ruleForm.schoolTypeId, //	学校类型id	number
            templateName: this.ruleForm.templateName //	模板名称	string
          };
          if (this.orderWay && this.largeSmall != 1) {
            query.orderWay = 0;
          }
          for (let item of this.currlist) {
            if (item.id == this.ruleForm.currId) {
              query.currName = item.name; //学科名称
            }
          }
          for (let item of this.schoolTypelist) {
            if (item.id == this.ruleForm.schoolTypeId) {
              query.schoolType = item.name; //学科名称
            }
          }
          if (this.largeSmall == 1) {
            let num = 1;
            for (let items of this.bigquestionlist) {
              let name = "";
              for (let item of this.questiontypelist) {
                if (items.queTypeId == item.id) {
                  name = item.value; //题型名称
                }
              }
              if (name == "") {
                this.$message.error("请选择第"+num+"题目题型！");
                return;
              }
              if (items.totalScore == "") {
                this.$message.error("第"+num+"大题总分不能为空！");
                return;
              }
              let obj = {
                queTypeId: items.queTypeId, //	题型id
                queTypeName: name, //	题型名称	number
                topicNum: num, //	大题题号	number
                totalScore: items.totalScore //	大题总分	number
              };
              num++;
              query.questionJson.push(obj);
            }
          } else {
            let bignum = 1;
            let smallnum = 1;
            for (let items of this.smallquestionlist) {
              let name = "";
              for (let item of this.questiontypelist) {
                if (items.queTypeId == item.id) {
                  name = item.value; //学科名称
                }
              }
              if (name == "") {
                this.$message.error("请选择第"+bignum+"大题题型！");
                return;
              }
              if (items.numlist[0].datalist.length == 0) {
                this.$message.error("第"+bignum+"大题小题数不能为空为零！");
                return;
              }
              for (let item of items.numlist[0].datalist) {
                let obj = {
                  queCount: items.numlist[0].datalist.length, //	小题数目
                  queNum: item.name, //	小题题号
                  queScore: item.num, //	小题分数
                  queTypeId: items.queTypeId, //	题型id
                  queTypeName: name, //	题型名称	number
                  topicNum: bignum, //	大题题号	number
                  totalScore: items.numlist[0].totalScore //	大题总分	number
                };
               if (!item.num) {
                this.$message.error("第"+bignum+"大题第"+item.name+"小题分数不能为空为零！");
                return;
               }
                query.questionJson.push(obj);
              }
              bignum++;
            }
          }
          if (query.questionJson.length < 1) {
            this.$message.error("模板不能没有题目！");
            return;
          }
          query.questionJson = JSON.stringify(query.questionJson);
          insertTemplate(query)
            .then(res => {
              const data = res.data;
              if (data.code == 200) {
                this.$message({
                  message: "创建成功！",
                  type: "success",
                  duration: 1000
                });
                this.$router.go(-1);
              }
            })
            .catch(err => {});
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.achievementadd {
  padding: 12px;
  .header {
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  .subject {
    overflow: auto;
    padding-top: 15px;
    .demo-ruleForm {
      overflow: hidden;
    }
    .el-form-item {
      width: 50%;
      float: left;
      min-width: 420px;
      max-width: 620px;
      .el-select {
        width: 100%;
      }
    }

    .formlist {
      margin-top: 10px;
    }
    .tablebox {
      margin-top: 10px;
    }
    .input-box {
      width: 225px;
      display: inline-block;
      margin-right: 30px;
    }
    .input-box-big {
      width: 120px;
    }
    .subjecttop {
      max-width: 800px;
    }
    .largebox {
      padding-left: 40px;
      padding-bottom: 20px;
      font-size: 14px;
    }
    .boxlist i {
      border: 1px #8492a6 solid;
      padding: 3px;
      font-size: 12px;
      border-radius: 50%;
      color: #8492a6;
      cursor: pointer;
    }
    .boxlist i:hover {
      border: 1px #20a0ff solid;
      color: #20a0ff;
    }
    .boxlist .el-icon-minus:hover {
      border: 1px #f76260 solid;
      color: #f76260;
    }
    .top {
      border-bottom: 1px solid #e7eaec;
      padding: 10px 0;
    }
    .subject {
      padding-top: 10px;
    }
    .el-select,
    .el-input {
      width: 100%;
    }
    .subject-title {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      margin: 10px 0;
      border-left: 3px solid #20a0ff;
      padding-left: 10px;
      margin-left: 10px;
    }
    .subject-title .span-red {
      font-size: 14px;
      padding-left: 30px;
      color: red;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/achievement/achievementeidt.vue